import React, { Component } from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import "../../../assets/scss/carousel.scss";

export default class ImageCarousel extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}
  componentWillUnmount() {}

  render() {
    const { images, className } = this.props;
    var sliderSettings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToScroll: 1,
      adaptiveHeight: true,
      centerMode: false,
      useCSS: true,
    };

    return (
      <div className={`carousel-wrap ${className}`}>
        <Slider {...sliderSettings}>
          {images.length > 0
            ? images.map((img, index) => {
                return (
                  <div className="slide" key={index}>
                    <img src={img} />
                  </div>
                );
              })
            : ""}
        </Slider>
      </div>
    );
  }
}
